
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/layout/DashboardLayout';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
        <h1 className="text-6xl font-bold text-muted-foreground">404</h1>
        <h2 className="text-2xl font-semibold mt-4">Page Not Found</h2>
        <p className="text-muted-foreground mt-2 max-w-md">
          We couldn't find the page you were looking for. It might have been removed or moved to a different location.
        </p>
        <Button 
          className="mt-6"
          onClick={() => navigate('/')}
        >
          Return to Dashboard
        </Button>
      </div>
    </DashboardLayout>
  );
};

export default NotFound;
